import axios from 'axios';

let messageCancelToken;
let convCancelToken;
let CancelToken = axios.CancelToken; //eslint-disable-line

const getConvs = (axiosInstance, { userId, selectedConv, limit, cursor }) => {
    const params = new URLSearchParams();
    if (selectedConv) {
        params.set('selectedId', selectedConv);
    }
    if (limit) {
        params.set('limit', limit);
    }
    if (cursor) {
        params.set('cursor', cursor);
    }
    const queryString = params.toString();
    const querySuffix = queryString ? `?${queryString}` : '';
    const url = `v1/messaging/member/${userId}/conversations${querySuffix}`;
    if (convCancelToken) {
        convCancelToken();
    }
    return axiosInstance.get(url, {
        cancelToken: new CancelToken((c) => {
            convCancelToken = c;
        }),
    });
};

const getMessages = (axiosInstance, { userId, convId, before, after }) => {
    const params = new URLSearchParams();
    if (before) {
        params.set('before', before);
    }
    if (after) {
        params.set('after', after);
    }
    const queryString = params.toString();
    const querySuffix = queryString ? `?${queryString}` : '';
    const url = `v1/messaging/member/${userId}/conversations/${convId}/messages${querySuffix}`;
    if (messageCancelToken) {
        messageCancelToken();
    }
    return axiosInstance.get(url, {
        cancelToken: new CancelToken((c) => {
            messageCancelToken = c;
        }),
    });
};

const getParticipants = (axiosInstance, { userId, convId }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/participants`;
    return axiosInstance.get(url);
};

const startConv = (axiosInstance, { userId, conv }) => {
    const url = `v1/messaging/member/${userId}/conversations`;
    return axiosInstance.post(url, conv);
};

const postMessage = (axiosInstance, { userId, convId, message }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/messages`;
    return axiosInstance.post(url, message);
};

const setLastRead = (axiosInstance, { userId, convId, lastRead }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/read`;
    return axiosInstance.put(url, { lastRead });
};

const postReport = (axiosInstance, { userId, convId, values }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/reports`;
    return axiosInstance.post(url, values);
};

const archiveConv = (axiosInstance, { userId, convId }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/archive`;
    return axiosInstance.post(url);
};

const deleteConv = (axiosInstance, { userId, convId }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}`;
    return axiosInstance.delete(url);
};

const blockEntity = (axiosInstance, { userId, blockEntityRequest }) => {
    const url = `v1/messaging/member/${userId}/block`;
    return axiosInstance.post(url, blockEntityRequest);
};

const unblockEntity = (axiosInstance, { userId, unblockEntityRequest }) => {
    const url = `v1/messaging/member/${userId}/unblock`;
    return axiosInstance.post(url, unblockEntityRequest);
};

const getBlockedEntities = (axiosInstance, { userId }) => {
    const url = `v1/messaging/member/${userId}/blocked`;
    return axiosInstance.get(url);
};

export {
    getConvs,
    getMessages,
    getParticipants,
    startConv,
    postMessage,
    setLastRead,
    postReport,
    archiveConv,
    deleteConv,
    blockEntity,
    getBlockedEntities,
    unblockEntity,
};
